<template>
  <v-list dense class='pa-0' >
    <v-subheader class='py-0' v-if='at.title' v-text='at.title' />
    <v-divider></v-divider>
    <template v-for='(action, index) in actions' >
      <v-divider v-if='action.type === "divider"' :key='index' />
      <v-list-item v-else
        :key='action.id'
        @click='handleClick(action, at)'
        v-bind='action.attrs' >
        <v-list-item-avatar >
          <v-icon small v-text='action.icon' />
        </v-list-item-avatar>
        <v-list-item-content >
          <v-list-item-title v-text='action.title' />
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>
<script>
import AppointmentTypeActionListMixin from './AppointmentTypeActionListMixin'

export default {
  name: 'AppointmentTypeActionList',
  mixins: [AppointmentTypeActionListMixin],
  props: {
    value: { type: Object, required: true }
  },
  data () {
    return {
      at: {}
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.at = this.value
      }
    }
  },
  computed: {
    actions () {
      return this.getAppointmenttypeactions(this.at)
    }
  },
  methods: {
    handleClick (action, at) {
      console.log(action, at)
      this.$emit(action.id, at)
      if (action.onclick) {
        action.onclick(at)
      }
    }
  }
}
</script>
